import type { WorkflowCapabilities } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import {
	createResource,
	useResource,
	type ResourceStoreContext,
	type RouterDataContext,
} from '@atlassian/react-resource-router';
import { fetchWorkflowCapabilities } from './services/index.tsx';

export const RESOURCE_TYPE_KEY = 'ADMIN_WORKFLOW_CAPABILITIES';

export const workflowCapabilitiesResource = createResource<WorkflowCapabilities>({
	type: RESOURCE_TYPE_KEY,
	getKey: (matchedRoute) => {
		const { workflowId } = matchedRoute.match.params;
		return `${RESOURCE_TYPE_KEY}_${workflowId}`;
	},
	getData: async (routerContext: RouterDataContext, customContext: ResourceStoreContext) =>
		fetchWorkflowCapabilities(routerContext, customContext),
	maxAge: 0,
	isBrowserOnly: true,
});

export const useWorkflowCapabilities = () =>
	useResource<WorkflowCapabilities>(workflowCapabilitiesResource);
